module.exports = __webpack_public_path__ + "img/DE02244.503ed60c.png";